import { Injectable } from "@angular/core";
import * as CryptoJS from 'crypto-js';

@Injectable({
    providedIn: 'root'
})
export class EncryptService {
    // encrypt plaint text with key
    encryptString(plainText: string, enckey: string) {
        if (plainText != undefined) {
            let key = CryptoJS.enc.Utf8.parse(enckey);
            let iv = CryptoJS.enc.Utf8.parse(enckey);
            let encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(plainText), key, {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            });
            return encrypted.toString();
        }
    }

    // encrypted string will be decrypt to plaint text using encyption key
    decryptString(encryptString: string, enckey: string) {
        if (encryptString != undefined) {
            let key = CryptoJS.enc.Utf8.parse(enckey);
            let iv = CryptoJS.enc.Utf8.parse(enckey);
            let decrypted = CryptoJS.AES.decrypt(encryptString, key, {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            });
            return decrypted.toString(CryptoJS.enc.Utf8);
        }
    }
}